<template>
  <div>
    <div class="full-width q-mb-xl">
      <jt-dynamic-form
        class="formContainerComposition"
        ref="dynamicForm"
        v-if="formComposition"
        :inputs="formComposition[0].inputs"
        :relacionamentos="formComposition[0].relacionamentos"
        :model="formComposition[0].dadosForm"
        :interface="formComposition[0].nmInterface"
        form-class="form dynamic"
      />
    </div>
    <div class="full-width text-center q-mr-xl self-center">
      <q-btn class="btnSave" color="info" @click="insert">
        <translate>ADD</translate>
      </q-btn>
    </div>
    <q-btn
      v-if="inputsMultiple"
      class="q-py-xs q-mx-md"
      icon="add"
      color="primary"
      @click="addForm"
    >
      <q-tooltip>
        <translate>ADD</translate>
      </q-tooltip>
    </q-btn>
    <div class="full-width q-mb-lg">
      <div>
        <span class="text-primary text-bold q-px-md">{{ titleAdded }} </span>
        <div class="bg-grey-3 rounded-borders body-grid full-width q-px-md q-pt-xs q-pb-md">
          <jt-data-table
            v-if="columnsTable.columns"
            id="jt-composition"
            class="q-mt-sm"
            :ref="'jtDataTable' + this.nmInterface"
            :api-mode="false"
            :data="dadosForm[this.name]"
            :fields="columnsTable.columns"
            :is-paginated="false"
            :buttons="columnsTable.buttons"
            :title="titleTeble"
            row-buttons
            noneselect
            @action-button="actionButton"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'

@Component({
  name: 'OpenComposition',
  components: { JtDataTable },
  props: {
    elements: Array,
    nmInterfaceComp: {
      type: String,
      required: true
    },
    inputs: {
      type: Array,
      required: false
    },
    inputsMultiple: {
      type: Array,
      required: false
    },
    dadosForm: {
      type: Object,
      required: true
    },
    mountedComposition: {
      type: Function,
      required: false
    },
    name: {
      type: String,
      required: true
    },
    onInsertComposition: {
      type: Function,
      required: false
    },
    titleTeble: {
      type: String,
      required: false
    }
  }
})
class OpenComposition extends Vue {
  formComposition = null;
  columnsTable = {};
  nmInterface = null;
  hideBottom = true;
  hideRemove = false;

  async mounted () {
    this.formComposition = await repository.resolve(this.nmInterfaceComp, {
      client: this.dadosForm.client
    })
    this.nmInterface = this.nmInterfaceComp.split('.')[0]
    this.columnsTable = this.elements[0].inputs.find(
      (x) => x.type == 'COMPOSICAO' && x.model == this.name
    )
    if (this.mountedComposition) this.mountedComposition(this)
  }

  computedColumns (columnsTable) {
    let columns = []
    if (columnsTable) {
      columns = columnsTable.map((column) =>
        Object.assign(column, { align: 'center' })
      )
    }
    return columns
  }

  addForm () {
    const inputsMultiple = this.formComposition[0].inputs.filter(
      (input) => this.inputsMultiple.indexOf(input.name) > -1
    )
    inputsMultiple.forEach((item) => {
      this.formComposition[0].inputs.push(item)
    })
  }

  actionButton (button, params, table) {
    if (button.name === 'icExcluirComposicao') {
      this.removerLinha(table.rowsSelectedNumber)
    }
  }

  async insert () {
    if (this.$refs.dynamicForm.isValidForm()) {
      try {
        const {
          data: { dadosGrid }
        } = await repository.manterComponente(this.nmInterfaceComp, {
          method: 'salvarComposicao',
          composicaos: this.dadosForm[this.name],
          flComposicaoAlteracao: false,
          ...this.formComposition[0].dadosForm,
          nrLinhaSelecionada: null
        })

        this.handleDadosGrid(dadosGrid)

        this.dadosForm[this.name].push(dadosGrid)
        this.formComposition[0].dadosForm = {}
      } catch (error) {
        console.error('TabelaBeneficioAposentadoCompositionPage.insert', error)
      }
    }
  }

  handleDadosGrid (dadosGrid) {
    this.$emit('handleDadosGrid', dadosGrid)
  }

  removerLinha (rowIndex) {
    this.elements[0].dadosForm[this.name].splice(rowIndex, 1)
  }
}
export default OpenComposition
</script>
<style lang="stylus" scoped>

#jt-composition .q-table__top{
  background: #eee !important;
}

.body-grid{
  .jt-datatable .q-table__bottom, .jt-datatable thead tr {
      background-color: #d6dbde;
  }
}
</style>
